import order from '../en/setting'

const cnSetting = {}

for (const cn in order) {
  cnSetting[cn] = cn
}

export default cnSetting
